/* Abba & Co. cap page (spec v14). All text is rendered by the theme; this only switches state. */
(function () {
  var dataEl = document.getElementById('acp-data');
  if (!dataEl || !document.querySelector('.acp')) return;
  var root = document;
  var D = JSON.parse(dataEl.textContent);
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var mqDesk = window.matchMedia('(min-width: 900px)');
  function track(name, detail) {
    try { document.dispatchEvent(new CustomEvent('abba:' + name, { detail: detail })); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('abba_' + name, detail || {}); } catch (e) {}
  }

  /* one challenge record per cap, per device */
  var KEY = 'abba.challenge.' + D.handle;
  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch (e) { return null; } }
  function save(v) { try { v ? localStorage.setItem(KEY, JSON.stringify(v)) : localStorage.removeItem(KEY); } catch (e) {} }

  /* gallery: thumbnails choose the shot, dots choose the detail */
  var shots = D.shots || [], hotspots = D.hotspots || [];
  var shot = 0, step = hotspots.length ? hotspots[0].n : 0;
  var imgs = $$('.acp-gallery__img');
  function placeDots() {
    $$('.acp-hs').forEach(function (b) {
      var m = !mqDesk.matches;
      b.style.left = (m ? b.dataset.xm : b.dataset.x) + '%';
      b.style.top = (m ? b.dataset.ym : b.dataset.y) + '%';
    });
  }
  function renderGallery() {
    var s = shots[shot];
    if (!s) return;
    imgs.forEach(function (img) { var on = img.dataset.view === s.view; img.classList.toggle('acp-is-on', on); img.setAttribute('aria-hidden', String(!on)); });
    var cur = null;
    var here = hotspots.filter(function (x) { return x.view === s.view; });
    if (here.length) {
      var h = here.filter(function (x) { return x.n === step; })[0] || here[0];
      step = h.n;
      cur = { n: String(h.n), kind: h.kind, title: h.title, text: h.text };
    }
    $$('.acp-hs').forEach(function (b) {
      b.hidden = b.dataset.view !== s.view;
      b.setAttribute('aria-pressed', String(typeof openN === 'number' && Number(b.dataset.n) === openN));
    });
    $$('.acp-thumb').forEach(function (t, i) { t.setAttribute('aria-pressed', String(i === shot)); });
  }
  /* the detail tile opens beside the tapped number, inside the photo */
  var tip = $('#acp-tip'), stage = $('.acp-gallery__stage'), openN = null;
  function closeTip(returnFocus) {
    if (!tip || openN === null) return;
    var was = $('.acp-hs[data-n="' + openN + '"]');
    tip.classList.remove('acp-is-on'); tip.hidden = true; openN = null;
    $$('.acp-hs').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-pressed', 'false'); });
    if (returnFocus && was) was.focus();
  }
  function openTip(b) {
    var h = hotspots.filter(function (x) { return x.n === Number(b.dataset.n); })[0];
    if (!tip || !h) return;
    $('.acp-tip__kind', tip).textContent = h.kind || '';
    $('.acp-tip__title', tip).textContent = h.title || '';
    $('.acp-tip__text', tip).textContent = h.text || '';
    tip.hidden = false;
    if (mqDesk.matches) {
      /* beside the dot, toward the nearer edge of the photo when it fits (the cap sits in the middle), kept inside the photo */
      var sw = stage.clientWidth, sh = stage.clientHeight, tw = tip.offsetWidth, th = tip.offsetHeight;
      var cx = b.offsetLeft, cy = b.offsetTop, gap = 34;
      var fitsRight = cx + gap + tw <= sw - 12, fitsLeft = cx - gap - tw >= 12;
      var goRight = cx >= sw / 2 ? fitsRight || !fitsLeft : !fitsLeft && fitsRight;
      if (cx < sw / 2 && fitsLeft) goRight = false;
      var left = goRight ? cx + gap : cx - gap - tw;
      var top = Math.min(Math.max(cy - th / 2, 12), sh - th - 12);
      left = Math.min(Math.max(left, 12), sw - tw - 12);
      tip.style.left = left + 'px'; tip.style.top = top + 'px';
    } else { tip.style.left = ''; tip.style.top = ''; }
    requestAnimationFrame(function () { tip.classList.add('acp-is-on'); });
    openN = h.n;
    $$('.acp-hs').forEach(function (x) { x.setAttribute('aria-expanded', String(x === b)); x.setAttribute('aria-pressed', String(x === b)); });
  }
  $$('.acp-hs').forEach(function (b) {
    b.addEventListener('click', function () {
      var n = Number(b.dataset.n);
      if (openN === n) { closeTip(false); return; }
      step = n; renderGallery(); openTip(b); track('hotspot', { n: step });
    });
  });
  if (tip) {
    $('.acp-tip__close', tip).addEventListener('click', function () { closeTip(true); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeTip(true); });
    window.addEventListener('resize', function () { var b = openN !== null && $('.acp-hs[data-n="' + openN + '"]'); if (b) openTip(b); });
  }
  $$('.acp-thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      shot = Number(t.dataset.shot); var s = shots[shot];
      var first = hotspots.filter(function (x) { return x.view === s.view; })[0];
      if (first) step = first.n;
      closeTip(false); renderGallery(); track('shot', { label: s.label });
    });
  });
  placeDots(); renderGallery();

  /* story: the whole declaration folds under one bar (#acp-more), so inside it every part is open on every screen */
  function setStory() { $$('.acp-story details').forEach(function (d) { d.open = true; }); }
  setStory();
  mqDesk.addEventListener('change', function () { setStory(); placeDots(); });
  $$('.acp-story summary').forEach(function (s) { s.addEventListener('click', function (e) { e.preventDefault(); }); });

  /* a link or shared URL that points inside the fold (#week, #passage...) opens it first, so it never lands on hidden text */
  var more = document.getElementById('acp-more');
  function openFor(hash) {
    if (!more || !hash || hash.length < 2) return;
    var t = document.getElementById(decodeURIComponent(hash.slice(1)));
    if (t && more.contains(t) && !more.open) { more.open = true; setTimeout(function () { t.scrollIntoView(); }, 0); }
  }
  openFor(location.hash);
  window.addEventListener('hashchange', function () { openFor(location.hash); });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (a) openFor(a.getAttribute('href'));
  });

  /* desktop index follows the reader */
  var links = $$('.acp-index a');
  if ('IntersectionObserver' in window && links.length) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) links.forEach(function (a) { a.classList.toggle('acp-is-on', a.getAttribute('href') === '#' + e.target.id); }); });
    }, { rootMargin: '-40% 0px -55% 0px' });
    links.forEach(function (a) { var el = document.getElementById(a.getAttribute('href').slice(1)); if (el) io.observe(el); });
  }
  var jump = $('.acp-jump'); if (jump) jump.addEventListener('click', function () { track('jump_to_challenge'); });

  /* reserve bar: only after the main button has scrolled away, never over the challenge */
  var mainBtn = document.querySelector('.acp-buy [type=submit], .acp-buy button[name=add]');
  var bar = document.querySelector('.acp-reserve-bar'), challenge = document.getElementById('week');
  if (bar && mainBtn && 'IntersectionObserver' in window) {
    var past = false, inChallenge = false;
    var sync = function () {
      var on = past && !inChallenge;
      bar.classList.toggle('acp-is-on', on);
      bar.setAttribute('aria-hidden', String(!on));
      $$('a,button', bar).forEach(function (x) { x.tabIndex = on ? 0 : -1; });
    };
    new IntersectionObserver(function (es) { var e = es[0]; past = !e.isIntersecting && e.boundingClientRect.top < 0; sync(); }).observe(mainBtn);
    if (challenge) new IntersectionObserver(function (es) { inChallenge = es[0].isIntersecting; sync(); }, { threshold: 0 }).observe(challenge);
    $$('[data-reserve]', bar).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); track('reserve_click', { from: 'bar' });
        mainBtn.scrollIntoView({ block: 'center', behavior: mqDesk.matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto' });
        try { mainBtn.focus({ preventScroll: true }); } catch (err) {}
      });
    });
  }
  if (mainBtn) mainBtn.addEventListener('click', function () { track('reserve_click', { from: 'main' }); });

  /* the challenge */
  var form = document.getElementById('acp-challenge-form');
  if (form && D.steps && D.steps.length) {
    var acceptBtn = document.getElementById('acp-accept'), hint = document.getElementById('acp-accept-hint'), chosen = -1;
    var pick = document.getElementById('acp-challenge-pick'), done = document.getElementById('acp-challenge-done');
    var radios = function () { return $$('input[name=acp-challenge]', form); };
    radios().forEach(function (r) {
      r.addEventListener('change', function () {
        chosen = Number(r.value); acceptBtn.setAttribute('aria-disabled', 'false');
        hint.textContent = D.ui.hintReady; track('challenge_pick', { step: chosen + 1 });
      });
    });
    var showAccepted = function (rec) {
      var s = D.steps[rec.step];
      document.getElementById('acp-ccard-title').textContent = s.title;
      document.getElementById('acp-ccard-text').textContent = s.text;
      $$('.acp-day').forEach(function (b, i) { var on = !!rec.days[i]; b.setAttribute('aria-pressed', String(on)); b.textContent = on ? '✓' : String(i + 1); });
      document.getElementById('acp-day-count').textContent = D.ui.dayCount.replace('[n]', rec.days.filter(Boolean).length);
      pick.hidden = true; done.hidden = false;
      var stepField = document.getElementById('acp-email-step'); if (stepField) stepField.value = String(rec.step + 1);
    };
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (chosen < 0) { hint.textContent = D.ui.hintChoose; return; }
      var rec = { step: chosen, days: [false, false, false, false, false, false, false], started: new Date().toISOString().slice(0, 10) };
      save(rec); showAccepted(rec); track('challenge_accept', { step: chosen + 1 });
      document.getElementById('acp-ccard').focus();
    });
    $$('.acp-day').forEach(function (b, i) {
      b.addEventListener('click', function () {
        var rec = load(); if (!rec) return; rec.days[i] = !rec.days[i]; save(rec); showAccepted(rec);
        track('challenge_day', { day: i + 1, on: rec.days[i] });
      });
    });
    document.getElementById('acp-reset').addEventListener('click', function () {
      save(null); chosen = -1; radios().forEach(function (r) { r.checked = false; });
      acceptBtn.setAttribute('aria-disabled', 'true'); hint.textContent = D.ui.hintChoose;
      done.hidden = true; pick.hidden = false;
    });
    var existing = load(); if (existing && D.steps[existing.step]) { chosen = existing.step; showAccepted(existing); }

    document.getElementById('acp-share').addEventListener('click', function () {
      var url = location.href.split('#')[0] + '#week';
      var text = D.ui.shareText.replace('[cap]', D.capName);
      var status = document.getElementById('acp-share-status');
      if (navigator.share) { navigator.share({ title: D.capName, text: text, url: url }).then(function () { track('challenge_share', { via: 'native' }); }).catch(function () {}); return; }
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text + ' ' + url).then(function () { status.textContent = D.ui.copied; track('challenge_share', { via: 'copy' }); }).catch(function () { status.textContent = url; });
      } else { status.textContent = url; }
    });

    document.getElementById('acp-save-card').addEventListener('click', function () {
      var rec = load(); if (!rec) return; var s = D.steps[rec.step];
      var W = 1080, H = 1350, cv = document.createElement('canvas'); cv.width = W; cv.height = H; var x = cv.getContext('2d');
      function wrap(t, font, max, lh, y, color) {
        x.font = font; x.fillStyle = color; var words = t.split(' '), line = '';
        for (var i = 0; i < words.length; i++) { var test = line ? line + ' ' + words[i] : words[i]; if (x.measureText(test).width > max && line) { x.fillText(line, 96, y); line = words[i]; y += lh; } else line = test; }
        x.fillText(line, 96, y); return y + lh;
      }
      var logo = new Image(); logo.crossOrigin = 'anonymous';
      logo.onload = function () { draw(true); }; logo.onerror = function () { draw(false); }; logo.src = D.logo;
      function draw(withLogo) {
        x.fillStyle = '#F5F1E8'; x.fillRect(0, 0, W, H);
        x.fillStyle = '#1F2A44'; x.fillRect(0, 0, W, 14); x.fillStyle = '#FF6B2C'; x.fillRect(0, 24, W, 14);
        if (withLogo && logo.naturalWidth) x.drawImage(logo, 96, 110, 300, 300 * logo.naturalHeight / logo.naturalWidth);
        x.fillStyle = '#20231F'; x.font = '500 30px Jost, Arial, sans-serif'; x.textAlign = 'right'; x.fillText(D.reference.toUpperCase(), W - 96, 150); x.textAlign = 'left';
        x.fillStyle = '#FF6B2C'; x.font = '500 30px Jost, Arial, sans-serif'; x.fillText(D.ui.cardKicker.toUpperCase(), 96, 300);
        var y = wrap(s.title, '400 64px "Libre Baskerville", Georgia, serif', W - 192, 80, 400, '#20231F');
        y = wrap(s.text, '400 36px Jost, Arial, sans-serif', W - 192, 54, y + 20, '#20231F');
        var bx = 96, gap = 16, sz = (W - 192 - gap * 6) / 7, by = Math.max(y + 60, 820);
        for (var i = 0; i < 7; i++) {
          var X = bx + i * (sz + gap); x.strokeStyle = '#20231F'; x.lineWidth = 3; x.strokeRect(X, by, sz, sz);
          x.textAlign = 'center';
          if (rec.days[i]) { x.fillStyle = '#20231F'; x.fillRect(X, by, sz, sz); x.fillStyle = '#FF6B2C'; x.font = '500 54px Jost, Arial'; x.fillText('✓', X + sz / 2, by + sz * .68); }
          else { x.fillStyle = '#20231F'; x.font = '500 34px Jost, Arial'; x.fillText(String(i + 1), X + sz / 2, by + sz * .62); }
          x.textAlign = 'left';
        }
        x.fillStyle = '#20231F'; x.font = 'italic 400 40px "Libre Baskerville", Georgia, serif'; x.fillText(D.ui.cardTag, 96, by + sz + 110);
        var url; try { url = cv.toDataURL('image/png'); } catch (err) { if (withLogo) draw(false); return; }
        var a = document.createElement('a'); a.download = D.handle + '-challenge.png'; a.href = url; document.body.appendChild(a); a.click(); a.remove();
        track('challenge_save_card', { step: rec.step + 1 });
      }
    });
  }
})();

/* "Your note goes inside, if it's a gift" chooses A gift, as on the live page (blocks/abbaco-trust) */
(function () {
  if (window.abbacoTrust) return;
  window.abbacoTrust = true;
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-ab-choose-gift]');
    if (!link) return;
    event.preventDefault();
    var scope = link.closest('.product-details, product-form-component, main') || document;
    var gift = scope.querySelector('input[name="properties[For]"][value="A gift"]');
    if (!gift) return;
    gift.click();
    var to = scope.querySelector('[data-ab-for-name]');
    if (to) setTimeout(function () { to.focus(); }, 50);
  });
})();

/* "Message us" opens the store chat in place; without the chat app the link goes to the contact page */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('[data-acp-chat]');
  if (!a) return;
  var chat = document.querySelector('shopify-chat');
  if (chat && typeof chat.show === 'function') { e.preventDefault(); chat.show(); }
});

/*
  How the story is read (owner, 2026-10-26). Counts only, per cap, sent to the reading record named in the
  chapter's settings, and only when the visitor allows analytics. Each signal is sent at most once a visit.
  A part counts as read when it stays on screen for at least half the time it takes to read it (230 words a
  minute, about six characters a word); a part that came on screen and left sooner counts as skimmed.
*/
(function () {
  var ch = document.getElementById('declaration');
  if (!ch || !ch.dataset.reading || !ch.dataset.cap) return;
  var url = ch.dataset.reading.replace(/\/$/, '') + '/reading';
  var sent = {}, queue = [], consent = null;

  try {
    if (window.Shopify && Shopify.customerPrivacy) consent = Shopify.customerPrivacy.analyticsProcessingAllowed();
    else if (window.Shopify && Shopify.loadFeatures) Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err && Shopify.customerPrivacy) { consent = Shopify.customerPrivacy.analyticsProcessingAllowed(); flush(); } });
  } catch (e) {}
  document.addEventListener('visitorConsentCollected', function (e) { consent = !!(e.detail && e.detail.analyticsAllowed); flush(); });

  function add(s) { if (sent[s]) return; sent[s] = true; queue.push(s); }
  function flush() {
    if (!queue.length || consent !== true) return;
    var body = JSON.stringify({ cap: ch.dataset.cap, signals: queue.splice(0) });
    try {
      if (navigator.sendBeacon) navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' }));
      else fetch(url, { method: 'POST', body: body, keepalive: true, mode: 'no-cors' });
    } catch (e) {}
  }

  /* the verse, and opening the story */
  var verse = ch.querySelector('.acp-verse'), more = document.getElementById('acp-more');
  if ('IntersectionObserver' in window && verse) new IntersectionObserver(function (es, o) { if (es[0].isIntersecting) { add('verse_seen'); o.disconnect(); } }, { threshold: 0.6 }).observe(verse);
  if (more) more.addEventListener('toggle', function () { if (more.open) add('story_open'); });

  /* read or skimmed, part by part */
  var parts = ['passage', 'then', 'father', 'week'].map(function (id) {
    var el = document.getElementById(id);
    if (!el) return null;
    var words = el.textContent.replace(/\s+/g, ' ').length / 6;
    return { id: id, el: el, need: words / 230 * 60 * 1000 * 0.5, shown: 0, since: 0, seen: false };
  }).filter(Boolean);
  function stop(p) { if (p.since) { p.shown += Date.now() - p.since; p.since = 0; } if (p.shown >= p.need) add('read:' + p.id); }
  if ('IntersectionObserver' in window && parts.length) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var p = parts.filter(function (x) { return x.el === e.target; })[0];
        if (!p) return;
        if (e.isIntersecting && !document.hidden) { p.seen = true; if (!p.since) p.since = Date.now(); } else stop(p);
      });
    }, { threshold: 0.25 });
    parts.forEach(function (p) { io.observe(p.el); });
    setInterval(function () { parts.forEach(function (p) { if (p.since && p.shown + Date.now() - p.since >= p.need) add('read:' + p.id); }); }, 2000);
  }
  function leaving() {
    parts.forEach(function (p) { stop(p); if (p.seen && !sent['read:' + p.id]) add('skim:' + p.id); });
    flush();
  }
  document.addEventListener('visibilitychange', function () { if (document.hidden) leaving(); });
  window.addEventListener('pagehide', leaving);

  /* the response: one tap, then the line that stayed */
  var respond = ch.querySelector('[data-respond]');
  if (respond) {
    var spoke = respond.querySelector('[data-spoke]'), lines = respond.querySelector('[data-lines]'), thanks = respond.querySelector('[data-respond-thanks]');
    spoke.addEventListener('click', function () {
      spoke.setAttribute('aria-pressed', 'true'); add('spoke'); flush();
      if (lines) { lines.hidden = false; var first = lines.querySelector('button'); if (first) first.focus(); } else if (thanks) thanks.hidden = false;
    });
    if (lines) lines.addEventListener('click', function (e) {
      var b = e.target.closest('[data-line]');
      if (!b || sent['line:' + b.dataset.line]) return;
      lines.querySelectorAll('[data-line]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); x.disabled = true; });
      add('line:' + b.dataset.line); flush();
      if (thanks) thanks.hidden = false;
    });
  }

  /* the challenge already announces itself (abba:challenge_accept) */
  document.addEventListener('abba:challenge_accept', function () { add('challenge'); flush(); });
})();
